import React from "react";
import { getVerificationMeta } from "./Map/markersData";

const STATUS_LABELS = {
  fresh: "Fresh",
  aging: "60+ days",
  stale: "120+ days",
};

const StatusBadge = ({
  status,
  verificationStatus,
  lastVerified,
  daysSinceVerification,
}) => {
  const calculated = getVerificationMeta(lastVerified);
  const resolvedStatus = ["fresh", "aging", "stale"].includes(
    verificationStatus || status
  )
    ? verificationStatus || status
    : calculated.verificationStatus;
  const resolvedDays = Number.isFinite(daysSinceVerification)
    ? daysSinceVerification
    : calculated.daysSinceVerification;

  return (
    <div className="verification-badge-wrap">
      <span className={`verification-badge verification-badge--${resolvedStatus}`}>
        <span className="verification-badge__dot" aria-hidden="true" />
        {STATUS_LABELS[resolvedStatus]}
      </span>
      <span className="verification-badge__age">
        Last verified {resolvedDays} {resolvedDays === 1 ? "day" : "days"} ago
      </span>
    </div>
  );
};

export default StatusBadge;
